import { createReducer } from '../../../../store.model';

import {
    DeleteTranscript,
    DeleteTranscriptResult,
} from './state/delete-transcript.action';
import {
    deleteTranscriptReducer,
    deleteTranscriptResultReducer,
} from './state/delete-transcript.reducer';
import { FilterSummary } from './state/filter-summary.action';
import { filterSummaryReducer } from './state/filter-summary.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { SortSummary } from './state/sort-summary.action';
import { sortSummaryReducer } from './state/sort-summary.reducer';
import { ToggleCategoryTranscript } from './state/toggle-category-transcript.action';
import { toggleCategoryTranscriptReducer } from './state/toggle-category-transcript.reducer';
import { ToggleCategory } from './state/toggle-category.action';
import { toggleCategoryReducer } from './state/toggle-category.reducer';
import { ActionType } from './transcript-summary.action';
import {
    defaultState,
    TranscriptSummaryState,
} from './transcript-summary.state';

const { builder, reducer } = createReducer<ActionType, TranscriptSummaryState>(
    defaultState(),
);

builder.add<Reload>(ActionType.COACHING_DETAIL__TS__RELOAD, reloadReducer);
builder.add<ReloadResult>(
    ActionType.COACHING_DETAIL__TS__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<DeleteTranscript>(
    ActionType.COACHING_DETAIL__TS__DELETE_TRANSCRIPT,
    deleteTranscriptReducer,
);
builder.add<DeleteTranscriptResult>(
    ActionType.COACHING_DETAIL__TS__DELETE_TRANSCRIPT_RESULT,
    deleteTranscriptResultReducer,
);

builder.add<FilterSummary>(
    ActionType.COACHING_DETAIL__TS__FILTER_SUMMARY,
    filterSummaryReducer,
);

builder.add<SortSummary>(
    ActionType.COACHING_DETAIL__TS__SORT_SUMMARY,
    sortSummaryReducer,
);

builder.add<ToggleCategory>(
    ActionType.COACHING_DETAIL__TS__TOGGLE_CATEGORY,
    toggleCategoryReducer,
);

builder.add<ToggleCategoryTranscript>(
    ActionType.COACHING_DETAIL__TS__TOGGLE_CATEGORY_TRANSCRIPT,
    toggleCategoryTranscriptReducer,
);

export const transcriptSummaryReducer = reducer;
